



















































import { Vue, Component, Prop } from 'vue-property-decorator';
import { institutionServer, roleServe, menuServe, userServe } from '@/api/installServer';
import logger from 'vuex/types/logger';
import TreeContainer from '@/components/tree/tree.vue';
import { arrayToTree } from '@/util/arrayToTree'; // 导入树状图
import { deepClone } from '@/util/deepClone';
import CollapseTransition from '@/components/collapseTransition/collapseTransition';
import tree from '@/components/tree/tree.vue';
import index from '@/filter';
@Component({
  components: { CollapseTransition, TreeContainer },
})
export default class RoleAssignDataPermissions extends Vue {
  @Prop(String) rowId!: string; // 传递给 角色分配数据权限 页面的表单数据对象
  editRoleFlag = 3; // 角色分配数据权限的标记
  // 机构权限树状图数据
  dendrogrampartFlag = false; // 授权数据权限部分
  scrollbar = false;
  roleAssignDataPermissionsData: any = {
    id: '',
    name: '',
    // spaceId: '',
    dataScopeType: '',
    menuIdList: [],
    customDeptIdList: [],
  };
  roleAssignDataPermissionsDataClone: any = {};
  private helpCustomDeptIdList: any = []; // 解决部门列表树不作更改操作时会自动保存空数组的问题
  // 树状图的数据
  menuTree: any[] = [];
  companyTree: any[] = [];
  roleTreeData: any[] = [];
  organTree: any[] = [];
  radioData: Array<any> = [
    {
      index: 0,
      label: '全部数据',
      flag: false,
      value: 'all',
    },
    {
      index: 1,
      label: '自定义数据',
      flag: true,
      value: 'custom',
    },
    {
      index: 2,
      label: '本公司数据',
      flag: false,
      value: 'currentSpace',
    },
    {
      index: 3,
      label: '本部门数据',
      flag: false,
      value: 'currentDeptAndSubDept',
    },
  ];

  /**
   * @todo 后期需要优化的部分
   * @desc 点击按钮返回角色管理界面
   * @param1 暂无
   * @returns 暂无
   */
  backRole(): void {
    this.$emit('close');
  }

  Rules: object = {};

  radioClick() {
    // console.log(this.roleAssignDataPermissionsData.dataScopeType);
    if (this.roleAssignDataPermissionsData.dataScopeType == 'custom') {
      this.scrollbar = false;
    } else {
      this.scrollbar = true;
    }
  }

  mounted() {
    this.hasScrollbar();
  }

  hasScrollbar() {
    const dom: any = document.getElementById('main_box');
    this.scrollbar = dom.scrollHeight > dom.clientHeight || dom.offsetHeight > dom.clientHeight;
  }

  created() {
    // 初始化树状图和表单的数据
    setTimeout(() => {
      this.getAllInfo();
    }, 500);
    this.getTreeData();
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 这些是上一个页面返回来的数据
   * @param1 暂无
   * @returns 暂无
   */
  getAllInfo(): void {
    // 通过id获取数据
    if (this.editRoleFlag === 3) {
      roleServe
        .getRoleLineData(this.rowId)
        .then((res: any) => {
          // console.log('有用的数据', res.data);
          this.roleAssignDataPermissionsData = res.data;
          // console.log(this.roleAssignDataPermissionsData.customDeptIdList);
          this.helpCustomDeptIdList = this.roleAssignDataPermissionsData.customDeptIdList;
          // this.roleAssignDataPermissionsDataClone = deepClone(res.data);
          // console.log('roleAssignDataPermissionsData', this.roleAssignDataPermissionsData);
          // console.log('roleAssignDataPermissionsDataClone', this.roleAssignDataPermissionsDataClone);
          this.$forceUpdate();
        })
        .catch((error: any) => {
          // this.$message({
          //   type: 'info',
          //   message: '网络错误，请检查网络',
          // });
          console.log(error);
        });
    }
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 获取 树状图 的数据
   * @param1 暂无
   * @returns 暂无
   */
  getTreeData(): void {
    // 初始化 树状图的数据
    menuServe
      .getCurrentSpace({})
      .then((res: any) => {
        this.menuTree = arrayToTree(res.data);
      })
      .catch(() => {
        this.$message.error('初始化树状图数据失败，请稍后重试！');
      });

    userServe
      .getCurrentOrgTree({})
      .then((res: any) => {
        // this.organTree = arrayToTree(res.data);
        // console.log(this.treeNameChange(res.data));

        const mapTree = (org: any) => {
          const haveChildren = Array.isArray(org.child) && org.child.length > 0;
          return {
            id: org.id,
            name: org.name,
            pid: org.pid,
            spaceId: org.spaceId,
            type: org.type,
            valid: org.valid,
            children: haveChildren ? org.child.map((i: any) => mapTree(i)) : [],
          };
        };
        let arr = [];
        arr = res.data.map((org: any) => mapTree(org));
        // console.log(arr,'arr....')
        this.organTree = arr;
      })
      .catch(() => {
        this.$message.error('初始化树状图数据失败，请稍后重试！');
      });

    // this.getAllInfo();
  }

  treeNameChange(item: any): any {
    if (item.child) {
      item.children = item.child;
      return this.treeNameChange(item.children);
    }
    return item;
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击按钮保存 获取树状图 点击时候的数据
   * @param1 暂无
   * @returns 暂无
   */
  getData(data: any) {
    // console.log(data);
    // this.roleAssignDataPermissionsData.menuIdList = data.idList;
    this.roleAssignDataPermissionsData.menuIdListChange = data.idList;
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击按钮保存 获取树状图 点击时候的数据
   * @param1 暂无
   * @returns 暂无
   */
  getOrganData(data: any) {
    // console.log(data);
    this.roleAssignDataPermissionsData.customDeptIdListChange = data.idList;
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击按钮保存 角色分配数据权限 页面内容
   * @param1 暂无
   * @returns 暂无
   */
  saveEditRole(): void {
    if (this.roleAssignDataPermissionsData.customDeptIdListChange === undefined) {
      this.roleAssignDataPermissionsData.customDeptIdListChange = this.helpCustomDeptIdList;
    }
    this.roleAssignDataPermissionsData.customDeptIdList = this.roleAssignDataPermissionsData.customDeptIdListChange;
    this.roleAssignDataPermissionsData.menuIdList = this.roleAssignDataPermissionsData.menuIdListChange;
    roleServe
      .editRoleData({ ...this.roleAssignDataPermissionsData })
      .then((res: any) => {
        this.backRole(); // 跳转到 index 页面
        this.$message.success('修改授权功能菜单成功！');
      })
      .catch(() => {
        this.$message.error('修改授权功能菜单失败,请稍后重试!');
      });
  }
}
